var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{staticClass:"verification_code",style:({'top':_vm.top?_vm.top+'px':''}),attrs:{"disabled":_vm.disabled,"type":"primary"},on:{"click":_vm.clickHandel}},[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }